// src/routes/productsRoutes.jsx
import React from 'react';
import { Route } from 'react-router-dom';
import Products from '../pages/products/Products';
import CreateProduct from '../pages/products/CreateProduct';
import EditProduct from '../pages/products/EditProduct';
import ProtectedRoute from '../components/global/ProtectedRoute';

const productsRoutes = (
    <>
        {/* Products List */}
        <Route
            path="/products"
            element={
                <ProtectedRoute requiredPermission="products_list">
                    <Products />
                </ProtectedRoute>
            }
        />

        {/* Products Archive */}
        <Route
            path="/products/archive"
            element={
                <ProtectedRoute requiredPermission="products_archive_list">
                    <Products />
                </ProtectedRoute>
            }
        />

        {/* Create Product */}
        <Route
            path="/products/create"
            element={
                <ProtectedRoute requiredPermission="products_create">
                    <CreateProduct />
                </ProtectedRoute>
            }
        />

        {/* Edit Product */}
        <Route
            path="/products/:id/edit"
            element={
                <ProtectedRoute requiredPermission="products_edit">
                    <EditProduct />
                </ProtectedRoute>
            }
        />
    </>
);

export default productsRoutes;
